import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { agentsLogin, baseUrl, lang } from "../../../store/APILinks";

export const AgentLLogin = createAsyncThunk(
  "agent/login",
  async (agentData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}/${agentsLogin}`, agentData, {
        headers: {
          Accept: "application/json",
          "Accept-Language": lang,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const AgentRegisterHandler = (builder) => {
  builder
    .addCase(AgentLLogin.pending, (state) => {
      state.loading = true;
    })
    .addCase(AgentLLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.agentData = action.payload;
      state.error = null;
    })
    .addCase(AgentLLogin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
};
